import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { feeTypeConst, loanTypeConst, typeOfSaleConst } from '../auctionFees.const';
import { ManageAuctionFeesService } from '../manage-auction-fees.service';
import { AuctionFeesSearch, AuctionFeetype } from '../models/AuctionFees';

@Component({
  selector: 'app-edit-auction-fees',
  templateUrl: './edit-auction-fees.component.html',
  styleUrls: ['./edit-auction-fees.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [ManageAuctionFeesService]
})
export class EditAuctionFeesComponent implements OnInit {

  @Output() cancelEditEvent = new EventEmitter<boolean>();
  @Output() setBreadCrumbs = new EventEmitter<any[]>();
  @Output() objMessage = new EventEmitter<{}>();
  @Output() reload = new EventEmitter<boolean>();
  @Input() currentRecord: AuctionFeetype;

  public editAuctionFeesForm: FormGroup = new FormGroup({
    ClientId: new FormControl('', Validators.required),
    LoanType: new FormControl('', Validators.required),
    TypeOfSale: new FormControl('', null),
    FeeType: new FormControl('', Validators.required),
    FeeAmount: new FormControl('', [Validators.required, Validators.pattern(/^[0-9]\d*(\.\d*)?$/)]),
  });
  clientIdControl = this.editAuctionFeesForm.get('ClientId');
  loanTypeControl = this.editAuctionFeesForm.get('LoanType');
  typeOfSaleControl = this.editAuctionFeesForm.get('TypeOfSale');
  feeTypeControl = this.editAuctionFeesForm.get('FeeType');
  feeAmountControl = this.editAuctionFeesForm.get('FeeAmount');
  processing: boolean;
  searchParams: AuctionFeesSearch;
  loanType = loanTypeConst;
  typeOfSale = typeOfSaleConst;
  feeType = feeTypeConst;
  selectedClientId: any;
  selectedLoantype: any;
  selectedFeeType: any;
  selectedTypeOfSale: any;
  feeAmount: string;
  clientId: any[];

  constructor(private manageAuctionFeesService: ManageAuctionFeesService) { }

  ngOnInit() {
    this.manageAuctionFeesService.getUniqueClientID().subscribe(res => {
      this.clientId = res.data;
      this.selectedClientId = this.clientId.find(x => x.label.toString() == this.currentRecord.UniqueClientID.toString()).value;
      this.selectedLoantype = this.loanType.find(x => x.label.toLowerCase() == this.currentRecord.LoanType.toLowerCase()).value;
      this.selectedFeeType = this.feeType.find(x => x.label.toLowerCase() == this.currentRecord.FeeType.toLowerCase()).value;
      this.feeAmount = this.currentRecord.FeeAmount;
      this.selectedTypeOfSale = this.currentRecord.TypeOfSale !== null ? this.typeOfSale.find(x => x.label.toLowerCase() == this.currentRecord.TypeOfSale.toLowerCase()).value : '';
    });
  }

  hideEditAuctionFeesForm(): void {
    this.cancelEditEvent.emit(false);
    this.reload.emit(false);
    this.setBreadCrumbs.emit([{ label: 'Manage Auction Fees' }]);
  }

  submitEditAuctionFeesForm(): void {
    this.searchParams = <AuctionFeesSearch>{};
    this.searchParams.ClientId = this.clientIdControl.value == (null || undefined) ? '' : this.clientIdControl.value;
    this.searchParams.LoanType = this.loanTypeControl.value == (null || undefined) ? '' : this.loanTypeControl.value;
    this.searchParams.TypeOfSale = this.typeOfSaleControl.value == (null || undefined) ? '' : this.typeOfSaleControl.value;
    this.searchParams.FeeType = this.feeTypeControl.value == (null || undefined) ? '' : this.feeTypeControl.value;
    this.searchParams.FeeAmount = this.feeAmountControl.value == (null || undefined) ? '' : this.feeAmountControl.value;
    this.searchParams.AuctionFeesMatrixId = this.currentRecord.AuctionFeesMatrixId;
    this.processing = true;
    this.manageAuctionFeesService.update(this.searchParams).subscribe(res => {
      this.processing = false;
      if (!res.error && res.data.length > 0) {
        this.objMessage.emit({ 'severity': 'success', 'detail': 'Auction Fees  edited successfully.' });
        this.cancelEditEvent.emit(false);
        this.setBreadCrumbs.emit([{ label: 'Manage Auction Fees' }]);
      } else if (res.error && res.data.length == 0) {
        this.objMessage.emit({ 'severity': 'error', 'detail': res.messages[0] });
      }
    }, error => {
      this.processing = false;
      this.objMessage.emit({ 'severity': 'error', 'detail': error.message });
    })
  }
}
